import { render, staticRenderFns } from "./OrderHistory.vue?vue&type=template&id=8e7a4096&scoped=true&"
import script from "./OrderHistory.js?vue&type=script&lang=js&"
export * from "./OrderHistory.js?vue&type=script&lang=js&"
import style0 from "./OrderHistory.css?vue&type=style&index=0&id=8e7a4096&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e7a4096",
  null
  
)

export default component.exports